import React from "react";
import { useT } from "@/context/I18nContext";
import { Briefcase, HeartHandshake } from "lucide-react";
import { cn } from "@/lib/utils";

/** Segmented Business ↔ Care mode switcher.
 *  Only meaningful for users who have access to more than one portal. */
export default function ModeSwitch({ value, onChange, availableModes = ["business", "care"] }) {
  const t = useT();
  if (!availableModes || availableModes.length < 2) return null;
  return (
    <div
      role="tablist"
      aria-label={t("modes.modeSwitch")}
      className="inline-flex items-center gap-1 p-1 rounded-full border border-border bg-cream-100"
      data-testid="mode-switch"
    >
      {availableModes.includes("business") && (
        <button
          role="tab"
          aria-selected={value === "business"}
          data-testid="mode-switch-business"
          onClick={() => onChange("business")}
          className={cn(
            "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition",
            value === "business"
              ? "bg-white text-ink-900 shadow-card"
              : "text-ink-500 hover:text-ink-900"
          )}
        >
          <Briefcase className="h-3.5 w-3.5" strokeWidth={1.75} />
          {t("modes.business")}
        </button>
      )}
      {availableModes.includes("care") && (
        <button
          role="tab"
          aria-selected={value === "care"}
          data-testid="mode-switch-care"
          onClick={() => onChange("care")}
          className={cn(
            "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition",
            value === "care"
              ? "bg-white text-ink-900 shadow-card"
              : "text-ink-500 hover:text-ink-900"
          )}
        >
          <HeartHandshake className="h-3.5 w-3.5" strokeWidth={1.75} />
          {t("modes.care")}
        </button>
      )}
    </div>
  );
}
